import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, map, merge, Observable } from 'rxjs';

import { Alert, AlertLevel } from '../../models/alert.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private alertSubject = new BehaviorSubject<Alert | null>(null);
  alert$: Observable<Alert | null>;

  constructor() {
    const alertSubject = this.alertSubject.asObservable();
    const reset$ = alertSubject.pipe(
      delay(5000),
      map(_ => null)
    );

    this.alert$ = merge(alertSubject, reset$);
  }

  handleError(error: any) {
    if (error.title && error.message) {
      this.showError(error.title, error.message);
    } else {
      this.showError('¡Ups!', 'Ocurrió un error inesperado, por favor, inténtalo de nuevo más tarde.');
      console.error(error);
    }
  }

  show(alert: Alert) {
    this.alertSubject.next(alert);
  }

  showWarn(title: string, description: string) {
    this.alertSubject.next({
      title,
      description,
      level: AlertLevel.WARNING
    });
  }

  showError(title: string, description: string) {
    this.alertSubject.next({
      title,
      description,
      level: AlertLevel.ERROR
    });
  }

  showSuccess(title: string, description: string) {
    this.alertSubject.next({
      title,
      description,
      level: AlertLevel.SUCCESS
    });
  }

  cleanAlert() {
    this.alertSubject.next(null);
  }
}
